import { render, staticRenderFns } from "./judgeVote.vue?vue&type=template&id=73fcfb0d"
import script from "./judgeVote.vue?vue&type=script&lang=js"
export * from "./judgeVote.vue?vue&type=script&lang=js"
import style0 from "./judgeVote.vue?vue&type=style&index=0&id=73fcfb0d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports